import FileEditModal from './FileEditModal';
import './FileEditModal.scss';

export default FileEditModal;
